import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import '../css/main/404.sass'

class ErrorPage extends Component {
  render() {
    return (
      <div className="page-404">
        <div className="page-404-text">
          <h1>Oops</h1>
          <h3>An error has occurred</h3>
        </div>
        <div className="page-404-links">
          <Link to="/dashboard/overview" onClick={() => window.location.reload()}>Return to Dashboard</Link>
        </div>
        {/* <div className="error-box">
          <p>{this.props.error}</p>
        </div> */}
      </div>
    )
  }
}

export default ErrorPage;